import axios from "axios";

export default {
  namespaced: true,
  state: {
    vehicles: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    vehiclesMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = state.isReceiving==true ? true : false;
    },
    RECEIVED_VEHICLES(state, payload) {
      state.vehicles = payload;
      state.isReceiving = false;
    },
    RECEIVING_VEHICLES(state) {
      state.isReceiving = true;
    },
    STOP_RECEIVING_VEHICLES(state) {
      state.isReceiving = false;
    },
    RECEIVED_VEHICLE(state, payload) {
      state = Object.assign(state, {
        vehicles: [...state.vehicles, payload],
        isReceiving: false,
      })
    },
    RECEIVING_VEHICLE(state) {
      state.isReceiving = true;
    },
    UPDATED_VEHICLE(state, payload) {
      let index = state.vehicles.findIndex(vehicle => vehicle._id === payload._id);
      state = Object.assign(state, {
        vehicles: state.vehicles.map((vehicle, i) => {
          if (i === index) {
            return Object.assign({}, vehicle, payload);
          }
          return vehicle;
        }),
        isUpdating: false,
        vehiclesMessage: 'Vehicles has been updating!',
      })
    },
    UPDATING_VEHICLE(state) {
      state.isUpdating = true;
    },
    DELETED_VEHICLE(state, payload) {
      let indexToDelete = state.vehicles.findIndex(vehicle => vehicle._id === payload._id);
      let vehicles = [...state.vehicles];
      vehicles.splice(indexToDelete, 1);
      state = Object.assign(state, {
        vehicles: [...vehicles],
        isDeleting: false,
        idToDelete: null,
        vehiclesMessage: 'Vehicle has been Deleted!',
      });
    },
    DELETING_VEHICLE(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteVehicleItemRequest({dispatch}, payload) {
      try{
        dispatch("deletingVehicle", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/vehicleitem/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteVehicle", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    getVehiclesRequest({dispatch}) {
      dispatch("receivingVehicles");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/vehicles';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "GET", url: url, headers: headers})
      .then(res => {
        dispatch("receiveVehicles", res.data);
      })
    },
    updateVehicleRequest({dispatch}, payload) {
      dispatch("updatingVehicle");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/vehicle/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "PUT",url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateVehicle", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async updateVehicleItemRequest({dispatch}, payload) {
      dispatch("doNothing");
      try{
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/vehicleitem/' + payload.vehicleitemid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateVehicleImageRequest({dispatch}, payload) {
      dispatch("updatingVehicle");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];

      var url = 'https://api.tradexc.com:3000/update/vehicle/image/' + id;
      let data = new FormData();
      data.append('image', payload.vehicleimage, payload.imagename); 
      delete payload['vehicleimage'];
      for (let x in payload) {data.append(x, payload[x]);}
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      axios({method: "PUT", url: url,headers: headers,data: data})
      .then(function (res) {
        dispatch("updateVehicle", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    insertVehicleRequest({dispatch}, payload) {
      dispatch("receivingVehicles");
      let url;
      let data;
      let token = localStorage.getItem('token');
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      if(payload.vehicleimage !== undefined) {
        url = 'https://api.tradexc.com:3000/insert/vehicle/withimage';
        data = new FormData();
        data.append('image', payload.vehicleimage, payload.imagename); 
        delete payload['vehicleimage'];
        for (let x in payload) {data.append(x, payload[x]);}
      } else {
        url = 'https://api.tradexc.com:3000/insert/vehicle';
        data = payload;
      }
      axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveVehicle", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    async insertVehicleItemRequest({dispatch}, payload) {
      try{
        dispatch("receivingVehicle");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/vehicleitem/' + payload.vehicleid;
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        dispatch("stopReceivingVehicles");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    deleteVehicleRequest({dispatch}, payload) {
      dispatch("deletingVehicle", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/delete/vehicle/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then(() => {
        dispatch("deleteVehicle", {_id: payload._id});
      })
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveVehicles({commit}, payload) {
      commit("RECEIVED_VEHICLES", payload)
    },
    receivingVehicles({commit}) {
      commit("RECEIVING_VEHICLES")
    },
    stopReceivingVehicles({commit}) {
      commit("STOP_RECEIVING_VEHICLES")
    },
    receiveVehicle({commit}, payload) {
      commit("RECEIVED_VEHICLE", payload)
    },
    receivingVehicle({commit}) {
      commit("RECEIVING_VEHICLE")
    },
    updateVehicle({commit}, payload) {
      commit("UPDATED_VEHICLE", payload)
    },
    updatingVehicle({commit}) {
      commit("UPDATING_VEHICLE")
    },
    deleteVehicle({commit}, payload) {
      commit("DELETED_VEHICLE", payload)
    },
    deletingVehicle({commit}, payload) {
      commit("DELETING_VEHICLE", payload)
    }
  },
};
